import type { NextPageContext } from 'next/types';

export const isServerSideAuth = (context: NextPageContext): boolean => {
	return !!context?.req?.user?.id;
};
